import * as React from "react";
import EditableHeading from '../../EditableHeading';

import Icon from '../../../icons';
import ReactPlayer from 'react-player';
import CheckBox from "../../Checkbox";

export default class VideoTemplate extends React.Component {
    EditableHeading;
    checkBoxChange;
    constructor(props) {
        super(props);
        this.state={
            isOpen:false,
            checkboxValue:false,
            EditableMode:true
        }
        this.handleCheckboxChange=this.handleCheckboxChange.bind(this);
        this.showDialogueBox=this.showDialogueBox.bind(this);
    }

    componentDidMount(){
        if(this.props.data.CanModifyCaption){
            this.setState({
                EditableMode:this.props.data.CanModifyCaption
            })
        }
        else{
            this.setState({
                EditableMode:this.props.EditableMode
            })
        }
    }

    componentWillReceiveProps(newProps){
        if(newProps.isSelectAll !== this.props.isSelectAll){
            this.setState({
                checkboxValue: newProps.extraData.selectedFiles && newProps.extraData.selectedFiles.length > 0 && newProps.extraData.selectedFiles.filter(file => file.FileGuid === newProps.data.FileGuid).length > 0
            })

        }

    }

    handleCheckboxChange(e,file){
        this.setState({
            checkboxValue:(this.state.checkboxValue ? false:true)
        })
        this.props.handleSelectAllShow(!e.checked,file);
    }

    showDialogueBox(){
        this.props.showDialogueBox({
            flag: true,
            component: <ReactPlayer
                        className='react-player'
                        url={this.props.data.OpenFileUrl}
                        controls
                    />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        })
    }

    render() {
        const videoData=this.props.data;
        let TruncateFileName = this.props.truncateFileName(videoData.FileName);

        return (
            <div className="videoTemplate">
                <div className="flexGrow fileListing">
                    <>
                        {

                            (videoData.VideoFileName != null && videoData.VideoFileName!="") ?
                                <div className="filesThumb alignMiddle" onClick={this.showDialogueBox}>
                                    <span className="play_icon">
                                        <Icon name="video" className="video" />
                                    </span>
                                    <img src={videoData.ThumbFileUrl}/>
                                </div>
                             :  undefined
                        }
                        {
                            (videoData.VideoFileName === "") ? <div className="filesMain"><Icon name="uploadVideo" className="video" /></div> : <div className="playerWrapper hide"></div>
                        }
                    </>
                    <div className="fileInfo">
                        {
                            (videoData.IsMultiDownload) ?
                                <div className="checkboxArea">
                                    <CheckBox item={{id:(videoData.NoteId || '')+ videoData.FileGuid,checked:this.state.checkboxValue}}
                                    handleCheckbox={(event)=>this.handleCheckboxChange(event,videoData)} ref={ref=>this.checkBoxChange=ref}/>
                                </div> : null
                        }
                        <span className="fileName quickTooltip-bottom" data-quicktooltip={this.props.isPrintPreview ? null: videoData.FileName}>
                            {
                                (videoData.FileUrl && !this.props.isPrintPreview) ?  <a className="downloadLink" href={videoData.FileUrl} target="_blank">{TruncateFileName} ({videoData.FileSize}) <Icon name="download" className="icon ml" /></a> : <span>{TruncateFileName} ({videoData.FileSize})</span>
                            }
                        </span>
                        {
                            (this.state.EditableMode && !this.props.isPrintPreview) ?
                            <span>
                                <div className="inlineEditor">
                                    <EditableHeading
                                        heading={(videoData.Caption !== null && videoData.Caption.trim() == "")? '' : videoData.Caption}
                                        onHeadingEdited={this.props.handleSaveCaption}
                                        maxLength={180}
                                        id={videoData}
                                        // isOpen={this.state.isOpen}
                                        ListingComponent={true}
                                        //showEditButton={(videoData.Caption !== null && videoData.Caption.trim() == "") ? false : true}
                                        ref={editable => this.EditableHeading = editable}
                                    />
                                </div>
                                <div className="fileAction">
                                    {(videoData.Caption == null || videoData.Caption.trim() == "") ? null : <React.Fragment><a  href="javascript:void(0)" onClick={()=>{ this.EditableHeading.onEditClick()}} className="mr__1">Edit</a>
                                    <a className="deleteCaption" onClick={()=>this.props.handleDeleteCaption(videoData)}>Delete</a></React.Fragment>}
                                </div>
                            </span>
                            :
                            <div className="fileNameDisplay">{videoData.Caption}</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

